import { render, staticRenderFns } from "./info-form.vue?vue&type=template&id=58ad9dd7&lang=pug&"
import script from "./info-form.vue?vue&type=script&lang=js&"
export * from "./info-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports